import { SearchSpringBaseService } from 'custom-extensions/searchspring';

const placements = {
	BASK:	'basket-page',
	CTGY:	'no-results-page',
	INVC:	'confirmation-page',
	PROD:	'product-page',
	SEARCH:	'no-results-page',
	SFNT:	'home-page',
	SRCH:	'no-results-page'
};

export default class BeaconService extends SearchSpringBaseService {

	#beaconURL = 'https://beacon.searchspring.io/beacon';

	#category = 'searchspring.recommendations.user-interactions';

	constructor () {
		super();

		this._context = {
			context: {
				sessionId: this.getSessionID(),
				userId: this.getUser(),
				website: {trackingCode: window?.mivaJS?.SS_SITE_ID}
			}
		};
		this._seed = this.getSeed();
		this.tags = 'no-results';
		this.placement = this.getPlacement();
	}

	getSeed () {
		if (window.mivaJS.Page_Code === 'PROD') {
			return [{sku: window.mivaJS.Product_Code}];
		}

		if (window.mivaJS.Page_Code === 'BASK') {
			return this.getBasketCodes();
		}

		return '';
	}

	getPlacement () {
		let placement = new Map(Object.entries(placements)).get(window.mivaJS.Page_Code);

		return placement ? placement : 'other-page';
	}

	getProfileEventObject () {
		return {
			event: {
				context: this.getProfileContext(),
				profile: {
					placement: this.placement,
					seed: this._seed,
					tag: this.tags
				}
			}
		};
	}

	getProductEventObject (product) {
		return {
			event: {
				context: this.getProfileContext(),
				product: {
					id: product.id,
					mappings: {
						core: {
							name: product.name,
							price: product.price,
							sku: product.code,
							uid: product.id,
							url: product.url
						}
					},
					seed: this._seed
				}
			}
		};
	}

	getProfileContext () {
		return {
			placement: this.placement,
			tag: this.tags,
			type: 'product-recommendation'
		};
	}

	getBasketCodes () {
		const productCodeElems = document.getElementsByClassName('js-mini-basket-item');
		const productCodes = [];

		for (const productCodeElem of productCodeElems) {
			productCodes.push({sku: productCodeElem.getAttribute('data-product-code')});
		}

		return productCodes;
	}

	sendBeacon (tags = false, type = false, recommendations) {
		let profileEvents = [];

		if (!type) {
			throw new Error('No event type provided.');
		}

		if (tags) {
			this.tags = tags;
		}

		const profileObject = {
			category: this.#category,
			id: this.uid(),
			type: 'profile.' + type,
			...this.getProfileEventObject(),
			...this._context
		};

		// Add the profile render event
		profileEvents.push(profileObject);

		if (recommendations.length > 0) {
			const productObject = {
				category: this.#category,
				type: 'profile.product.' + type,
				...this._context,
				pid: profileObject.id
			};

			recommendations.forEach(product => {
				let productEvent = {
					id: this.uid(),
					...productObject,
					...this.getProductEventObject(product)
				};
				profileEvents.push(productEvent);
			});

		}

		this.sendRequest(profileEvents);
	}

	async sendRequest (body) {

		const url = this.#beaconURL;

		try {
			const response = await fetch(url, {
				body: JSON.stringify(body),
				headers: {
					'Content-Type': 'application/json'
				},
				method: 'POST'
			});

			if (!response.ok) {
				throw new Error(`${response.status} ${response.statusText}`);
			}

			const jsonResponse = await response.json();

			if (!jsonResponse || !jsonResponse.results.batch || jsonResponse.results.batch.length === 0) {
				return false;
			}
			return jsonResponse.results.batch;
		} catch (error) {
			console.log(error);
		}
	}
}
